import { DashboardState } from './dashboard.state';
import { DashboardContainerCodes } from '@mobile-data-access-enums';

export const dashboardInitialState: DashboardState = {
  containers: [DashboardContainerCodes.PLAN, DashboardContainerCodes.NAVIGATOR],
  loading: false,
};
